module.exports = __webpack_public_path__ + "img/send.e2e2868e.svg";